import React, { useEffect, useRef, useState } from "react";
import { Box, Container, Typography, Grid, Chip, Button as MuiButton } from "@mui/material";
import { ArrowForward, LaunchRounded } from "@mui/icons-material";
import SectionTitle from "../components/ui/SectionTitle/SectionTitle";
import TeamCard from "../components/ui/TeamCard/TeamCard";
import SponsorsSlider from "../components/ui/SponsorsSlider/SponsorsSlider";
import styles from "./About.module.scss";
import bannerStyles from "../components/common/WelcomeBanner/WelcomeBanner.module.scss";

// Import the team data we just created
import { teamMembers, TeamMember } from "../constants/teamData";

// =============================================================================
// ABOUT PAGE COMPONENT
// =============================================================================

const About: React.FC = () => {
    const [shuffledMembers, setShuffledMembers] = useState<TeamMember[]>([]);
    const sectionsRef = useRef<(HTMLElement | null)[]>([]);
    const animatedElementsRef = useRef<(HTMLElement | null)[]>([]);

    useEffect(() => {
        // Fisher-Yates shuffle algorithm to randomize the team members array
        const shuffleArray = (array: TeamMember[]) => {
            const newArray = [...array]; // Create a copy to avoid mutating the original
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
            }
            return newArray;
        };
        setShuffledMembers(shuffleArray(teamMembers));
    }, []); // Empty dependency array ensures this runs only once on mount

    return (
        <Container
            maxWidth={false}
            disableGutters
            className={styles.aboutPage}
            sx={{
                width: "100%",
                boxSizing: "border-box",
                overflowX: "hidden",
                paddingLeft: { xs: "16px", sm: "24px" },
                paddingRight: { xs: "16px", sm: "24px" },
            }}
        >
            {/* All '.animate' classes removed */}
            <section className={styles.introSection}>
                <Container maxWidth="lg">
                    <Box className={styles.introContainer}>
                        <div className={styles.logoContainer}>
                            <img
                                src="/MAX-Aspire-Logo.png"
                                alt="MAX Aspire Logo"
                                className={styles.logo}
                            />
                        </div>
                        <Typography variant="h2" className={styles.mainTitle}>
                            About MAX Aspire
                        </Typography>
                        <Typography variant="h6" className={styles.subtitle}>
                            Connecting Muslim professionals around the World through meaningful
                            networking, mentorship, and collaborative opportunities.
                            <br></br>
                            <br></br>
                            MAX Aspire is more than a platform — it&apos;s a movement to connect,
                            empower, and elevate Muslim talent through mentorship, opportunities,
                            and shared purpose.
                            <br />
                            <br />
                            Our Mission: To unlock the full potential of Muslim professionals
                            <br />
                            <br />
                            Our Vision: A future where Muslim excellence leads and inspires
                            <br />
                            <br />
                            Our Values: Faith. Impact. Community. Growth.
                            <br />
                            <br />
                            We&apos;re building this together.
                        </Typography>
                        <br></br>
                        <br></br>
                        <MuiButton
                            variant="contained"
                            className={bannerStyles.learnMoreButton}
                            onClick={() => window.open("http://onemax.org", "_blank")}
                            endIcon={<ArrowForward />}
                        >
                            More from MAX
                        </MuiButton>
                    </Box>
                </Container>
            </section>

            {/* <section className={styles.teamSection}>
                <Container maxWidth="lg">
                    <SectionTitle
                        title="Meet Our Team"
                        subtitle="The passionate individuals building the future of Muslim professional networking"
                    />

                    <div className={styles.teamGrid}>
                        {shuffledMembers.map((member, index) => (
                            <TeamCard
                                key={member.name}
                                name={member.name}
                                title={member.title}
                                image={`/team/${member.image}`}
                                linkedinUrl={member.linkedinUrl}
                            />
                        ))}
                    </div>
                </Container>
            </section> */}

            <section className={styles.sponsorsSection}>
                <Container maxWidth="lg">
                    <SectionTitle
                        title="Our Supporters"
                        subtitle="Proud to be supported by organizations that believe in our mission"
                    />

                    <div className={styles.sponsorsContainer}>
                        <SponsorsSlider autoPlay={true} speed={2000} />
                    </div>
                </Container>
            </section>
        </Container>
    );
};

export default About;
